import actions from '@/core/store/relatorios/controle-saldos/actions'

export default {
	actions,
}
